import addOnStore from 'Models/AddOnStore';
import useAsync from './useAsync';

/**
 * Call this hook in your component to for a re-render when passenger type store finishes fetching data.
 */
export default function useAddOns(userId?: string, refresh: boolean = false) {
	return useAsync(() => addOnStore.retrieveAddOnsAsync(refresh, userId), []);
}
